/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const inventoryAdjustmentLines = sqliteTable('inventory_adjustment_lines', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  inventory_adjustment_id: text('inventory_adjustment_id'),
  inventory_item_id: text('inventory_item_id'),
  inventory_batch_id: text('inventory_batch_id'),
  movement_direction: text('movement_direction'),
  quantity: real('quantity'),
  unit: text('unit'),
  reason: text('reason'),
  remarks: text('remarks'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
